/**
 *  排行榜单路由
 *  2017-11-21
 *  Bai.Zhiming
 */
"use strict";
angular.module("rankingListRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.rankinglist.portalranking", {
        url: "/portalranking",
        views: {
            "main@front.plan.rankinglist": {
                templateUrl: "./planningCenter/rankingList/portalRanking/portalRanking_tpl.html",
                controller: "portalRankingCtrl"
            }
        }
    }).
    state("front.plan.rankinglist.characterslist", {
        url: "/characterslist",
        views: {
            "main@front.plan.rankinglist": {
                templateUrl: "./planningCenter/rankingList/charactersList/charactersList_tpl.html",
                controller: "charactersListCtrl"
            }
        }
    }).
    state("front.plan.rankinglist.weixinarticlelist", {
        url: "/weixinarticlelist",
        views: {
            "main@front.plan.rankinglist": {
                templateUrl: "./planningCenter/rankingList/weixinArticleList/weixinArticleList_tpl.html",
                controller: "weixinArticleListCtrl"
            }
        }
    });
}]);